import { render, staticRenderFns } from "./ManageAdminCardsList.vue?vue&type=template&id=451c4072&scoped=true&"
import script from "./ManageAdminCardsList.vue?vue&type=script&lang=js&"
export * from "./ManageAdminCardsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451c4072",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('451c4072')) {
      api.createRecord('451c4072', component.options)
    } else {
      api.reload('451c4072', component.options)
    }
    module.hot.accept("./ManageAdminCardsList.vue?vue&type=template&id=451c4072&scoped=true&", function () {
      api.rerender('451c4072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/manage-admin-cards/ManageAdminCardsList.vue"
export default component.exports